export enum SmartDealPartyType {
  Admin = "Admin",
  Exporter = "Exporter",
  Importer = "Importer",
}
